import { ShowColumnsFilter } from "@/components/ColumnMenu";
import {
  ActionCellPopupSettings,
  ToggleCompanyActiveCell,
} from "@/components/custom-cells";
import { ICompany } from "@/interfaces/company.interface";
// import { ObjectTypeActionCellPopup, SubContractorActionCellPopup } from "../../shared-components/custom-cells";
import { MIN_RESIZABLE_WIDTH_KENDO_TABLE } from "@/utils/kendo";
import { Switch } from "@progress/kendo-react-inputs";

export interface columnInterface {
  title?: string;
  field?: string;
  show?: boolean;
  filter?: "boolean" | "numeric" | "text" | "date" | undefined;
  minWidth?: number;
  minGridWidth?: number;
  locked?: boolean;
  width?: string | number;
  columnMenu?: any;
  minResizableWidth?: number;
  cells?: any;
}

export const generateColumns = (
  handleEditClick: any,
  onColumnsSubmit: any,
  columnsExternal?: any,
  enableDisableCompany?: (dataItem: ICompany) => void,
  selectedProjectId?: string
): any => {
  const columns = [
    {
      title: "Name",
      field: "name",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <ActionCellPopupSettings
            rowData={props.dataItem}
            handleEditClick={handleEditClick}
            dataKey="name"
          />
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Location",
      field: "location",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Is External",
      field: "isExternal",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <td>
            <Switch
              checked={props.dataItem.isExternal}
              defaultChecked={props.dataItem.isExternal}
              onLabel="Yes"
              offLabel="No"
              disabled={true}
              name="IsExternal"
            ></Switch>
          </td>
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Is MEP",
      field: "isMep",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <td>
            <Switch
              checked={props.dataItem.isMep}
              onLabel="Yes"
              offLabel="No"
              disabled={true}
              name="isMep"
            ></Switch>
          </td>
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Active",
      field: "isActive",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => {
          const isActiveInProject = props.dataItem.projects?.some(
            (p: any) => p.id === selectedProjectId && p.isActive
          ) ?? false;
          return (
            <ToggleCompanyActiveCell
              {...props}
              dataItem={{ ...props.dataItem, isActive: isActiveInProject }}
              enableDisable={enableDisableCompany}
              disabeled={false}
            />
          );
        },
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
  ];

  return columns;
};
